import { LOAD_CRM_ARTICLES_SUCCESS, LOADING_CRM_ARTICLES, LOAD_CRM_ARTICLES_FAILED } from './actionTypes';

export function loadCrmKnowlegdeArticlesSuccess(crmArticles) {
    return { type: LOAD_CRM_ARTICLES_SUCCESS, crmArticles };
}

export function loadingCrmKnowlegdeArticles() {
    return { type: LOADING_CRM_ARTICLES };
}

export function loadCrmKnowlegdeArticlesFailed(error) {
    return { type: LOAD_CRM_ARTICLES_FAILED, error };
}